import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import messages from 'intl/messages';
import MyLink from 'features/home/components/MyLink';
import NavSizes from './NavSizes';
import NavLangs from './NavLangs';
import NavAuth from './NavAuth';
import { DarkLightSwitcher } from './DarkLightSwitcher';

const NavMain: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggle = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <nav
      className={classNames(
        'flex bg-[#563d7c] items-center justify-between py-2 px-4 flex-wrap'
      )}
    >
      <MyLink
        className='text-white inline-block whitespace-nowrap text-xl py-1'
        href='/'
      >
        Nonograms Online
      </MyLink>
      <button
        type='button'
        className='md:hidden'
        onClick={toggle}
        aria-label='Toggle navigation menu'
      >
        <span
          className='w-6 h-6 inline-block md:hidden nav-toggler'
        />
      </button>
      <div
        className={isOpen ? 'w-full' : 'hidden md:flex'}
      >
        <ul className='ml-auto flex flex-col md:flex-row'>
          <DarkLightSwitcher />
          <NavSizes />
          <NavLangs />
          <li>
            <MyLink
              className='text-white px-2'
              href='https://sudokucore.com/?utm_source=nonogram&utm_medium=crosslink'
              target='_blank'
              rel='noopener'
              useATag
            >
              <FormattedMessage {...messages.sudoku} />
            </MyLink>
          </li>
          <li>
            <MyLink
              className='text-white px-2'
              href='/apps'
            >
              <FormattedMessage {...messages.mobileApps} />
            </MyLink>
          </li>
          <li>
            <MyLink
              className='text-white px-2'
              href='/daily/archive'
            >
              <FormattedMessage {...messages.dailyArchive} />
            </MyLink>
          </li>
          <li>
            <MyLink className='text-white px-2' href='/how-to-solve'>
              <FormattedMessage {...messages.howToSolve} />
            </MyLink>
          </li>
          <li>
            <MyLink className='text-white px-2' href='/top'>
              <FormattedMessage {...messages.topTimes} />
            </MyLink>
          </li>
          <NavAuth />
          <li>
            <MyLink
              className='text-white px-2 md:hidden lg:inline-block'
              href={
                'https://www.facebook.com/pages/Nonograms-Online/46749863722'
              }
              target='_blank'
              rel='noopener noreferrer'
              useATag
            >
              Fb
            </MyLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavMain;

